import Chromosome from "./Chromosome";

class Genome {
  constructor(genomeId, chrs) {
    let start = 1;
    this.genomeId = genomeId;
    this.key = `${this.genomeId}:${chrs.map((x) => x.id).join("-")}`;
    this.chrObjectArr = chrs;
    this.chrs = chrs
      .map((x) => ({ ...x, g0: (start += x.size) - x.size }))
      .map((x) => ({ ...x, genomeId, size: x.size + 1 }))
      .map((x) => ({ ...x, name: `chr${x.key.toUpperCase()}` }))
      .map((x) => new Chromosome(x));

    this.idMap = this.chrs.reduce((a, i) => a.set(i.id, i), new Map());
    this.nameMap = this.chrs.reduce((a, i) => a.set(i.name, i), new Map());
    this.keyMap = this.chrs.reduce((a, i) => a.set(i.key, i), new Map());

    this.g0 = this.chrs[0].region.g0;
    this.g1 = this.chrs[this.chrs.length - 1].region.g1;
  }

  static toChrKey(name) {
    return name.toLowerCase().replace("chr", "");
  }

  findChr(position) {
    for (let i = 0; i < this.chrs.length; i++) {
      const chr = this.chrs[i];
      if (chr.region.contains(position)) return chr;
    }
    return this.chrs[0];
  }

  findChrsWithinRange(start, end) {
    const res = [];
    for (let i = 0; i < this.chrs.length; i++) {
      const { g0, g1 } = this.chrs[i].region;
      if (g1 > start && g0 < end) res.push(this.chrs[i]);
    }
    return res;
  }

  addChr(id, size, name) {
    const chr = { id, size, name, key: Genome.toChrKey(name) };
    return new Genome(this.genomeId, [...this.chrObjectArr, chr]);
  }

  getChrByName(name) {
    const key = Genome.toChrKey(name);
    return this.keyMap.get(key);
  }

  getChrByKey(key) {
    return this.keyMap.get(String(key).toLowerCase());
  }

  getChrById(id) {
    return this.idMap.get(id);
  }
}

export default Genome;
